export const MEMBER_ROUTES = {
	LIST: "/members",
	PROFILE: "/members/me",
	DETAIL: "/members/:userId",
} as const;
